import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { EventNames } from '../../directives/prevent-event/event-names';
import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-features-container-header',
  templateUrl: './features-container-header.component.html',
  styleUrls: ['./features-container-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesContainerHeaderComponent {
  @ViewChild('tooltip') tooltip: MatTooltip;
  @ViewChild('headerElement') headerElement: ElementRef;

  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() header: string;
  @Input() parentComponentSelector: string;

  readonly eventNames = EventNames;

  isShown: boolean;

  constructor() {}

  calculateIfTooltipNeeded(): void {
    // Functions takes control over tooltip - dynamically change tooltip's message and its state (show/hide)
    // Dynamically changed input in html caused change detection problems / UI bugs
    const isLabelTrimmed =
      this.headerElement.nativeElement.offsetWidth < this.headerElement.nativeElement.scrollWidth;

    if (isLabelTrimmed) {
      this.isShown = true;
      this.tooltip.message = this.header;
      this.tooltip.show();
    }
  }

  headerMouseLeave(): void {
    if (this.isShown) {
      this.tooltip.message = null;
      this.tooltip.hide();
      this.isShown = false;
    }
  }
}
